var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7066 7.29365C13.0973 7.68428 13.0973 8.31865 12.7066 8.70928L6.70664 14.7093C6.31602 15.0999 5.68164 15.0999 5.29102 14.7093C4.90039 14.3187 4.90039 13.6843 5.29102 13.2937L10.5848 7.9999L5.29414 2.70615C4.90352 2.31553 4.90352 1.68115 5.29414 1.29053C5.68477 0.899902 6.31914 0.899902 6.70977 1.29053L12.7098 7.29053L12.7066 7.29365Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.9403255b22e5063a7805224beed44851.svg";
export { ForwardRef as ReactComponent };